// import yokoso from '@/api/yokoso'
// import _ from 'lodash'
// import structure from '@/assets/structure.json'
import { getField, updateField } from 'vuex-map-fields'
const state = {
  // structure: null
  isYokosoHotel: false,
  people: {
    adult: 2,
    child: 0,
    childAge: []
  }

}
// getters
const getters = {
  getField,
  // structure: (state) => {
  //   return state.structure
  //
  isYokosoHotel: (state) => {
    return state.isYokosoHotel
  },
  people: (state) => {
    return state.people
  }
}

// actions
const actions = {
  updateChildAge: function ({ commit, state }, payload) {
    commit('SET_CHILD_AGE', payload)
  }
}

// mutations
const mutations = {
  updateField,
  SET_IS_YOKOSO_HOTEL: function (state, payload) {
    state.isYokosoHotel = payload
  },
  SET_ADULT: function (state, payload) {
    state.people.adult = payload
  },
  SET_CHILD: function (state, payload) {
    state.people.child = payload
  },
  SET_CHILD_AGE: function (state, payload) {
    const oldLength = state.people.childAge.length
    const newLength = payload.length
    if (newLength > oldLength) {
      console.debug('[ADD] childAge')
      for (let i = 0; i < newLength; i++) {
        if (i > oldLength || oldLength === 0) {
          state.people.childAge.push(payload[i])
        }
      }
    } else if (newLength < oldLength) {
      console.debug('[REMOVE] childAge')
      state.people.childAge.splice(newLength, oldLength)
    }
    for (let i = 0; i < newLength; i++) {
      state.people.childAge[i] = payload[i]
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
